import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from 'app/authentication/authentication.service';
import { Routes } from 'app/Routes';

@Injectable({
    providedIn: 'root'
})
export class AnonymousGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot): boolean {
        if (!this.authService.isLoggedIn()) {
            return true;
        }

        this.router.navigate([Routes.homepage]);
        return false;
    }
}
